import { useContext } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";

import { DashboardContext } from "context/Context";

const SalesUpsell = () => {
  const { company } = useContext(DashboardContext);
  const location = useLocation();
  const requestedPath = location.state?.from;
  const planName = company?.plan === 2 ? "Profit Optimizer" : "Market Radar";

  return (
    <div className="d-flex justify-content-center">
      <Card
        className="shadow-lg border-0 w-100 overflow-hidden"
        style={{
          fontFamily: '"Space Grotesk", "Avenir Next", sans-serif',
        }}
      >
        <Card.Body className="p-0">
          <style>{`
            @keyframes upsellFadeIn {
              from { opacity: 0; transform: translateY(8px); }
              to { opacity: 1; transform: translateY(0); }
            }
          `}</style>
          <div
            className="position-relative p-4 p-lg-5"
            style={{ animation: "upsellFadeIn 500ms ease" }}
          >
            <div
              className="position-absolute top-0 end-0 translate-middle-y"
              style={{
                width: "220px",
                height: "220px",
                filter: "blur(6px)",
                zIndex: 0,
              }}
            />
            <div
              className="position-absolute bottom-0 start-0 translate-middle"
              style={{
                width: "260px",
                height: "260px",
                filter: "blur(8px)",
                zIndex: 0,
              }}
            />
            <Row className="g-4 position-relative" style={{ zIndex: 1 }}>
              <Col lg={12}>
                <div
                  className="d-inline-flex align-items-center gap-2 rounded-pill px-3 py-1 mb-3"
                  style={{
                    position: "absolute",
                    top: "16px",
                    right: "16px",
                    background: "rgba(20, 20, 20, 0.06)",
                    fontSize: "12px",
                    letterSpacing: "0.08em",
                    textTransform: "uppercase",
                  }}
                >
                  Profit Optimizer
                </div>

                <h2 className="mb-2" style={{ fontSize: "30px", letterSpacing: "-0.02em" }}>
                  Activa ésta sección mejorando tu plan
                </h2>
                <p className="text-muted mb-3">
                  Esta seccion requiere el plan Profit Optimizer. Tu plan actual es{" "}
                  <strong>{planName}</strong>.
                </p>
                {requestedPath ? (
                  <div
                    className="d-inline-flex align-items-center rounded-pill px-3 py-1 mb-3"
                    style={{
                      background: "rgba(0,0,0,0.05)",
                      fontSize: "13px",
                    }}
                  >
                    Intentaste acceder a: {requestedPath}
                  </div>
                ) : null}
                <div className="mb-2" style={{ fontWeight: 600 }}>
                  Al actualizar, obtienes:
                </div>
                <ul className="mb-4 ps-4 text-muted">
                  <li className="mb-2">
                    Pronosticos y tendencias por ubicacion para ajustar precios.
                  </li>
                  <li className="mb-2">Calendario con ventas promedio y comparativos.</li>
                  <li className="mb-2">Analisis por rango de fechas y temporadas.</li>
                  <li className="mb-2">Cálculo de precio de óptima utilidad.</li>
                </ul>
                <div className="d-flex flex-column flex-sm-row gap-2">
                  <Link to="https://wa.me/528114706347" target="__blank">
                    <Button variant="primary">Contactar soporte</Button>
                  </Link>
                  <Link to="https://gasinador.com/#pricing" target="__blank">
                    <Button variant="outline-primary">Ver planes</Button>
                  </Link>
                </div>
              </Col>
              {/* <Col lg={12}>
                <div
                  className="ratio ratio-16x9 rounded-4 overflow-hidden border"
                  style={{
                    background:
                      "linear-gradient(160deg, rgba(12,12,12,0.9) 0%, rgba(36,36,36,0.85) 100%)",
                    borderColor: "rgba(0,0,0,0.08)",
                  }}
                >
                  <div className="d-flex align-items-center justify-content-center">
                    <div className="text-center text-white">
                      <div
                        className="d-inline-flex align-items-center justify-content-center rounded-circle mb-2"
                        style={{
                          width: "56px",
                          height: "56px",
                          background: "rgba(255,255,255,0.12)",
                          border: "1px solid rgba(255,255,255,0.25)",
                          fontSize: "22px",
                        }}
                      >
                        ▶
                      </div>
                      <div style={{ fontSize: "13px", letterSpacing: "0.08em" }}>Video demo</div>
                      <div className="text-white-50" style={{ fontSize: "12px" }}>
                        2 min
                      </div>
                    </div>
                  </div>
                </div>
                <div className="text-muted mt-2" style={{ fontSize: "13px" }}>
                  Vista rapida de la seccion de Ventas.
                </div>
              </Col> */}
            </Row>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default SalesUpsell;
